import { useIntl } from 'react-intl';
import RadioButton from '@rio-cloud/rio-uikit/RadioButton';
import { APPROVAL_TYPE_OPTIONS, REQUEST_TYPE_OPTIONS } from '../constants';
import { getOptionLabel } from '../../../../../../utils/aeg';
import { AegFormSectionProps, AegApprovalTypeEnum, AegRequestTypeEnum } from '../../../../../../models/newAEG';

const RequestInfoSection = ({ values, errors, requiredFields, onChange }: AegFormSectionProps) => {
    const intl = useIntl();
    const requiredMessage = intl.formatMessage({ id: 'intl-msg:support.custom.fieldRequired' });

    return (
        <section className='border rounded padding-15'>
            <h3 className='display-flex align-items-center gap-x-2 margin-top-0 margin-bottom-15 text-size-16 text-bold'>
                <span className='rounded-circle bg-primary text-color-white text-size-12 width-25 height-25 inline-flex items-center justify-center shrink-0'>
                    1
                </span>
                {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.section.request' })}
            </h3>
            <div className='grid grid-cols-[minmax(0,1fr)] sm:grid-cols-2 gap-x-4 gap-y-3'>
                <div className='form-group margin-bottom-0' role='radiogroup' aria-labelledby='aeg-request-type-label'>
                    <span
                        id='aeg-request-type-label'
                        className='display-block text-size-12 text-medium text-color-dark'
                    >
                        {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.field.requestType' })}{' '}
                        {requiredFields.includes('requestType') && <span className='text-color-danger'>*</span>}
                    </span>
                    <div className='aeg-radio-group'>
                        {REQUEST_TYPE_OPTIONS.map(option => (
                            <RadioButton
                                key={option.id}
                                name='aeg-request-type'
                                value={option.id}
                                checked={values.requestType === option.id}
                                onChange={() => onChange('requestType', option.id as AegRequestTypeEnum)}
                                inline
                            >
                                {getOptionLabel(option, intl)}
                            </RadioButton>
                        ))}
                    </div>
                    {errors.requestType && <span className='text-size-12 text-color-danger'>{requiredMessage}</span>}
                </div>
                <div className='form-group margin-bottom-0' role='radiogroup' aria-labelledby='aeg-approval-type-label'>
                    <span
                        id='aeg-approval-type-label'
                        className='display-block text-size-12 text-medium text-color-dark'
                    >
                        {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.field.approvalType' })}{' '}
                        {requiredFields.includes('approvalType') && <span className='text-color-danger'>*</span>}
                    </span>
                    <div className='aeg-radio-group'>
                        {APPROVAL_TYPE_OPTIONS.map(option => (
                            <RadioButton
                                key={option.id}
                                name='aeg-approval-type'
                                value={option.id}
                                checked={values.approvalType === option.id}
                                onChange={() => onChange('approvalType', option.id as AegApprovalTypeEnum)}
                                inline
                            >
                                {getOptionLabel(option, intl)}
                            </RadioButton>
                        ))}
                    </div>
                    {errors.approvalType && <span className='text-size-12 text-color-danger'>{requiredMessage}</span>}
                </div>
            </div>
        </section>
    );
};

export default RequestInfoSection;
